import React, { useMemo } from "react";
import { Stack, Text, Button, Divider, Group } from "@mantine/core";
import moment from "moment";
import {
  SelectedService,
  ServiceSchedule,
} from "../../../../../../types/availability";
import styles from "./RebookModal.module.css";

interface ConfirmRebookingStepProps {
  selectedServices: SelectedService[];
  serviceSchedules: Record<string, ServiceSchedule>;
}

export default function ConfirmRebookingStep({
  selectedServices,
  serviceSchedules,
}: ConfirmRebookingStepProps) {
  // Calculate total price
  const totalPrice = useMemo(() => {
    return selectedServices.reduce((sum, service) => sum + service.price, 0);
  }, [selectedServices]);

  // Format combined date and time for display
  const formatDateTime = (date: string, time: string) => {
    const dateTime = moment(`${date} ${time}`, "YYYY-MM-DD • HH:mm");
    return dateTime.format("MMM DD, YYYY [at] h:mm A");
  };

  return (
    <Stack gap="xs">
      {/* Service Cards */}
      {selectedServices.map((service) => {
        const schedule = serviceSchedules[service.id];

        return (
          <div key={service.id} className={styles.confirmCard}>
            <div className={styles.confirmCardHeader}>
              <Text className={styles.confirmServiceName}>
                {service.serviceName}
              </Text>
              <Text>${service.price.toFixed(2)}</Text>
            </div>

            <div className={styles.confirmDetails}>
              <div>
                <Text fw={500} size="sm" c="dimmed" tt="uppercase">
                  When
                </Text>
                <Text size="sm" c="dimmed">
                  {formatDateTime(schedule?.date || "", schedule?.time || "")}
                </Text>
              </div>
              <div>
                <Text fw={500} size="sm" c="dimmed" tt="uppercase">
                  Provider
                </Text>
                <Text size="sm" c="dimmed">
                  {service.staffName}
                </Text>
              </div>
            </div>
          </div>
        );
      })}

      {/* Total */}
      <Group ml="auto" align="flex-end" mr="xs">
        <Text className={styles.totalLabel}>Total</Text>
        <Text className={styles.totalAmount}>$ {totalPrice.toFixed(2)}</Text>
      </Group>
    </Stack>
  );
}
